import {geocodeByAddress,Suggestion} from "react-places-autocomplete";

export const validateGoogleAddress = async (location: string) =>{
  try {
    await geocodeByAddress(location);
  } catch (err) {
    return {
      location: "Invalid address",
    };
  }
}
